import React from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Skeleton,
} from "@mui/material";

const ServiceSkeleton: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mx: 2,
        marginBottom: 4,
      }}
    >
      <Card
        sx={{ height: 85, width: 240, backgroundColor: "#f7fafe" }}
        elevation={4}
      >
        <CardActionArea
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            px: 1,
            height: "100%",
          }}
        >
          <Skeleton
            variant="rectangular"
            width={62}
            height={62}
            sx={{ borderRadius: 1 }}
          />
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              width: 170,
              px: 1,
            }}
          >
            <Skeleton width="80%" height={20} />
            <Skeleton width="100%" height={20} />
          </CardContent>
        </CardActionArea>
      </Card>
    </Box>
  );
};

export default ServiceSkeleton;
